import { render, staticRenderFns } from "./ifp-filter-created-within-days.vue?vue&type=template&id=39b911a0&"
import script from "./ifp-filter-created-within-days.vue?vue&type=script&lang=ts&"
export * from "./ifp-filter-created-within-days.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports